<template>
  <section class="cta-section" aria-label="Call to action">
    <div class="cta-section__inner">
      <hr class="rule rule--ox" />
      <div class="cta">
        <p class="eyebrow cta__kicker">The Final Out &mdash; Subscribe</p>
        <h2 class="display-lg cta__heading">Ready to <em>explore?</em></h2>
        <p class="body-lg cta__dek">
          This is just the teaser. The real power lives in slicing and filtering across every
          dimension of the game &mdash; every plate appearance, every bullpen arm, every park
          effect.
        </p>
        <div class="cta__row">
          <router-link to="/login" class="btn-press">
            Sign Up to Explore
            <span class="btn-press__arrow">&rarr;</span>
          </router-link>
          <router-link to="/" class="btn-press btn-press--ghost">
            Back to the Front Page
          </router-link>
        </div>
        <p class="cta__fineprint">
          <span class="fineprint__dot">♦</span>
          No credit card required &middot; Pressbox Edition
          <span class="fineprint__dot">♦</span>
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// CTA section — no script logic
</script>

<style scoped>
.cta-section {
  max-width: 1280px;
  margin: 0 auto;
  padding: 3.5rem 2rem 5rem;
}

.cta {
  max-width: 680px;
  margin: 3rem auto 0;
  text-align: center;
}

.cta__kicker {
  justify-content: center;
  margin-bottom: 1.25rem;
}

.cta__heading {
  margin-bottom: 1.25rem;
}

.cta__heading em {
  font-style: italic;
  color: var(--ox);
}

.cta__dek {
  max-width: 58ch;
  margin: 0 auto 2.25rem;
  text-align: center;
}

.cta__row {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 1.75rem;
}

.btn-press__arrow {
  display: inline-block;
  transition: transform 0.18s ease;
}

.btn-press:hover .btn-press__arrow {
  transform: translateX(4px);
}

.cta__fineprint {
  font-family: var(--font-ui);
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  color: var(--ink-faint);
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}

.fineprint__dot {
  color: var(--ox);
}

@media (max-width: 700px) {
  .cta-section {
    padding: 2.5rem 1rem 3.5rem;
  }

  .cta__row {
    flex-direction: column;
  }

  .cta__row .btn-press {
    justify-content: center;
  }
}
</style>
